import { Select } from '@iwoca/orion';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { clsx } from 'clsx';
import { useFormContext } from 'react-hook-form';

import { TGetStartedDataDE } from './GetStartedDE';
import styles from './GetStartedDE.module.css';
import { useLocale } from '../../../hooks/useLocale';

export const LOAN_PURPOSE_OPTIONS_DE = [
  {
    label: msg`Stock purchase`,
    value: 'stock_purchase',
  },
  {
    label: msg`Bridging loan`,
    value: 'bridging_loan',
  },
  {
    label: msg`Marketing`,
    value: 'marketing',
  },
  {
    label: msg`Equipment purchase`,
    value: 'equipment_purchase',
  },
  {
    label: msg`Pay bill`,
    value: 'pay_bill',
  },
  {
    label: msg`Refinancing debt`,
    value: 'refinancing_debt',
  },
  {
    label: msg`Other`,
    value: 'other',
  },
] as const;

const LoanPurposeDE = () => {
  const { i18n } = useLocale();
  const { t } = useLingui();

  const {
    register,
    formState: { errors },
  } = useFormContext<TGetStartedDataDE>();

  return (
    <Select
      {...register('loanPurpose')}
      label={t`What do you want to use the loan for?`}
      placeholder={t`Please select`}
      className={clsx({
        [styles.erroredSelect]: errors.loanPurpose?.message,
      })}
      error={errors.loanPurpose?.message}
    >
      {LOAN_PURPOSE_OPTIONS_DE.map((option) => (
        <option key={option.value} value={option.value}>
          {i18n._(option.label)}
        </option>
      ))}
    </Select>
  );
};

export default LoanPurposeDE;
